import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';

import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { WireAssignedType } from '@/types/wireTypes';

export type BilledEventType = {
  id: string;
  date_created: string;
  is_kyc_required: boolean;
  organization: {
    id: string;
    name: string;
  };
  user: {
    email: string;
    id: string;
  };
  wire: {
    id: string;
    name: string;
    ref_id: string;
    type: WireAssignedType;
    contract: {
      id: string;
      name: string;
    };
  };
};

export type BilledEventResponseType = ApiResponseType<ListResponseType<BilledEventType>>;

export const getBilledEventsApi = async (params?: ApiParams): Promise<BilledEventResponseType> => {
  const uri = `/opco/events/wire/`;

  return authApiService.GET(uri, params);
};
